import React, { useEffect, useState, Fragment } from "react";
import { Formik, Form, Field } from "formik";
import axios from "axios";
import toast from "react-hot-toast";
import LinkButton from "../../utils/LinkButton";
import { useLocation } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import cursosimg from "../../static/images/cursos_default.png";
import EventItem from "./EventItem";

function EventsList({ data,col=6, SetTab, edit,dispatch, redirect }) {
  const [listCourses, setlistCourses] = useState([]);
  const [deleteCur] = useState("");
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  

  function GetCourses() {
    axios
      .get("/user/"+data.userId.userId+"/exclusive-events", )
      .then((result) => {
        setlistCourses(result.data);
      });
  }

  function sortEvent(e) {

    let { target: { value } } = e
    let _new = [];

    if (value === "0") {

      _new = listCourses.sort(function(a, b) {
        let date_1 = (new Date(a.startDate)).getTime()
        let date_2 = (new Date(b.startDate)).getTime()
  
        return date_2 - date_1;
      });
    } else {

      _new = listCourses.sort(function(a, b) {
        let date_1 = (new Date(a.startDate)).getTime()
        let date_2 = (new Date(b.startDate)).getTime()
  
        return date_1 - date_2;
      });

    }
    
    

    setlistCourses([..._new]);
  }

  function DeleteCourse() {

    axios.post("company-course/close/" + deleteCur, ).then((result) => {
      if (result.status === 200) {
        setShow(false);
        toast.success(result.data.message, {
          duration: 4000,
        });
        GetCourses();
      }
    });
  }

  useEffect(() => {

    function localFetch(data) {
      axios
      .get(`/user/${data.userId.userId}/exclusive-events`)
      .then((result) => {

        let _new = result?.data?.sort(function(a, b) {
          let date_1 = (new Date(a.startDate)).getTime()
          let date_2 = (new Date(b.startDate)).getTime()
    
          return date_2 - date_1;
        });

        setlistCourses(_new);
      });
    }

    if(data?.userId.userId) {
      localFetch(data)
    }
    

  }, [dispatch, data]);


  return (
    <Fragment>
      <div className="vacancy__description bordered-box vacantes perfil-empresa usuario">
      <div className="content" style={{ width: "100%" }}>
        <div className="tab-content" id="pills-tabContent">
          <div className="bordered-box__header">
            <div className="bordered-box__header-title">TUS PUBLICACIONES</div>
            <div className="col-6 d-flex justify-content-end select-class" id="divfiltro">
              <label for="staticEmail" className="col-sm-1 col-form-label">
              Filtrar: 
              </label>

              <select
                className="col-sm-8 form-select form-select-sm"
                id="filtroevento"
                aria-label="Default select example"
                onChange={sortEvent}
                defaultValue="0"
              >
                <option value="0" >Más reciente</option>
                <option value="1">Más antiguo</option>
              </select>
            </div>
          </div>
          <div className="courseList">
            <div className="mt-4 row">
       
              {listCourses.map((item, index) => (
                   <div className={`courseBox col-sm-${col} p-4}`}>
                      <EventItem item={item} index={index} setTab={SetTab} edit={edit} redirect={redirect}></EventItem>
                  </div>
              ))}

            </div>
          </div>
        </div>
      </div>
      </div>
      <Modal
        show={show}
        keyboard={false}
        dialogClassName="kr-modal"
        onHide={handleClose}
      >
        <Modal.Body>
          <div className="form form--white ">
            <div className="div__wrapper">
              <div className="form__title text-center">Eliminar Curso</div>
              <div className="form__row">
                <div className="col-sm-12 ">
                  <label htmlFor="names">Desea eliminar este registro?</label>
                </div>
              </div>
              <div className="form__row">
                <button
                  className="btn btn--gradient btn__icon btn__icon--door"
                  onClick={() => DeleteCourse()}
                >
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default EventsList;
